'use client';

import { useMemo } from 'react';
import {
  useListProfileConfigsQuery,
  useGetWidgetDefinitionsQuery,
} from 'src/api/redux/profileConfiguration';
import type {
  WidgetConfig,
  ProfileConfigWidget,
  ProfileWidget,
} from 'src/api/redux/profileConfiguration';

export const useProfileDisplayConfig = (entityType: string) => {
  const {
    data: allConfigs,
    isLoading: isLoadingConfigs,
    isError,
  } = useListProfileConfigsQuery();



  const { data: widgetDefinitions, isLoading: isLoadingWidgets } =
    useGetWidgetDefinitionsQuery();

  const isLoading = isLoadingConfigs || isLoadingWidgets;

  const config: WidgetConfig | null = useMemo(
    () => allConfigs?.results?.find((c) => c.entity_type === entityType) ?? null,
    [allConfigs, entityType]
  );

  const widgets: ProfileConfigWidget[] = useMemo(
    () =>
      [...(config?.widgets ?? [])].sort(
        (a, b) => a.display_order - b.display_order
      ),
    [config]
  );

  const availableWidgets: ProfileWidget[] = useMemo(
    () =>
      widgetDefinitions?.results?.filter((w) =>
        w.entity_types.includes(entityType)
      ) ?? [],
    [widgetDefinitions, entityType]
  );

  const isWidgetEnabled = useMemo(
    () => (widgetCode: string) => widgets.some((w) => w.code === widgetCode),
    [widgets]
  );

  return {
    isLoading,
    isError,
    config,
    configId: config?.id ?? null,
    widgets,
    availableWidgets,
    isWidgetEnabled,
  };
};

export default useProfileDisplayConfig;
